import PrivacyPolicy from 'components/Page/PrivacyPolicy/PrivacyPolicy';

export default PrivacyPolicy;
